import { abortableFetch, useEventCallback } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';

export function useDeleteChallengedActDialog() {
  const callApi = useEventCallback(
    (challengedActId: string, updateClosed = false) => {
      return abortableFetch(
        `${EvidenceApiUrl.ES_FILES}/challenged-act/${challengedActId}${
          updateClosed ? '/update-closed' : ''
        }`,
        {
          method: 'DELETE',
          headers: new Headers({
            'Content-Type': 'application/json',
          }),
        }
      );
    }
  );

  return {
    callApi,
  };
}
